import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import faqList from "./FAQlist.json";

function FAQ() {
  // FAQ 상태 관리
  const [faqs, setFaqs] = useState(faqList);

  const toggleFaq = (index) => {
    setFaqs(
      faqs.map((faq, i) =>
        i === index ? { ...faq, isOpen: !faq.isOpen } : faq
      )
    );
  };

  return (
    <section>
      <Container fluid className="home-about-section" id="about">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col md="auto">
              <h1 style={{ fontSize: "2.6em", marginTop: "20px" }}>
                <span className="purple"> FAQ </span>
              </h1>
            </Col>
          </Row>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col md="12" className="faq-section" style={{ textAlign: "left" }}>
              {faqs.map((faq, index) => (
                <div key={index} style={{ marginBottom: "15px" }}>
                  <h2
                    style={{
                      fontSize: "1.5em",
                      cursor: "pointer",
                      userSelect: "none",
                      marginLeft: "10%",
                    }}
                    onClick={() => toggleFaq(index)}
                  >
                    {faq.isOpen ? "▼" : "▶"} {faq.question}
                  </h2>
                  {faq.isOpen && (
                    <div
                      style={{
                        display: "flex", // Flexbox 설정 추가
                        justifyContent: "center",
                        alignItems: "center", // 세로 정렬 추가
                        marginLeft: "20px",
                      }}
                    >
                      <img
                        src={faq.answer}
                        alt={faq.question}
                        style={{
                          maxWidth: "75%",
                          height: "auto",
                        }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default FAQ;
